export enum eNonInterestPrepayments {
  homeowners_insurance = 'homeowners_insurance',
  mortgage_insurance = 'mortgage_insurance',
  property_tax = 'property_tax',
}

export const prettyNonInterestPrepayments: Record<eNonInterestPrepayments, string> = {
  [eNonInterestPrepayments.homeowners_insurance]: 'Homeowners Insurance',
  [eNonInterestPrepayments.mortgage_insurance]: 'Mortgage Insurance',
  [eNonInterestPrepayments.property_tax]: 'Property Tax',
};
